/* istanbul ignore file */

export enum SectionAction {
  TOGGLE_SECTION_VISIBILITY = 'toggle_section_visibility',
  DUPLICATE_SECTION = 'duplicate_section',
  DELETE_SECTION = 'delete_section',
  COPY_SECTION = 'copy_section',
  CUT_SECTION = 'cut_section',
}
